/**
 * @Author: zuokangsheng
 * @Date:   2021-11-24 11:34:49
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2025-04-01 17:53:59
 */
import util from "@/assets/js/common/util";
import equityLayout from "@/pages/layout/equity.vue";
import Layout from "@/pages/layout/layout.vue";
import store from "@/store/index.js";
import {
  getUserInfo,
  getUserinfoRights,
  getUserModuleAuth,
  LOGINURL,
} from "@/utils/apis";
import Vue from "vue";
import Router from "vue-router";
// 显示申请试用弹窗
const SHOW_APPLY_MODAL = "SHOW_APPLY_MODAL";
Vue.use(Router);
// {
//   path: "/equity",
//   name: "equity",
//   meta: {
//     keepAlive: true,
//     title: "权益中心",
//     auth: true,
//   }, // 需要被缓存
//   component: () => import("@/pages/equity/index"),
// },
// {
//   path: "/equity/:id",
//   name: "equity-detail",
//   meta: {
//     keepAlive: true,
//     title: "权益详情",
//     auth: true,
//   }, // 需要被缓存
//   component: () => import("@/pages/equity/detail"),
// },
var router = new Router({
  routes: [
    {
      path: "/data-board",
      name: "data-board",
      meta: {
        keepAlive: true,
        title: "数据看板",
        auth: true,
      },
      component: () => import("@/pages/data-board/index?schoolId=272"),
    },
    {
      path: "/download",
      name: "download",
      meta: {
        keepAlive: true,
        title: "我的下载",
        auth: true,
      }, // 需要被缓存
      component: () => import("@/pages/download/index"),
    },
    {
      path: "/collection",
      name: "collection",
      meta: {
        keepAlive: true,
        title: "我的收藏",
        auth: true,
      },
      component: () => import("@/pages/collection/index"),
    },
    {
      path: "/",
      meta: {
        title: "网校通",
        auth: true,
      },
      component: Layout,
    },
    {
      path: "*",
      meta: {
        title: "网校通",
        auth: true,
      },
      redirect: "/",
    },
    {
      path: "/noauth",
      name: "noauth",
      auth: false,
      component: () => import("@/pages/noAuth"),
    },
    {
      path: "/upgrade",
      name: "upgrade",
      meta: {
        title: "网校通",
        redirect: true,
      },
      component: () => import("@/pages/upgrade"),
    },
    {
      path: "/close-page",
      name: "closepage",
      meta: {
        title: "网校通",
        redirect: true,
      },
      component: () => import("@/pages/close-page"),
    },
    {
      meta: {
        keepAlive: true,
        title: "临时链接视频详情",
        auth: true,
      },
      path: "/lab/cj/*",
      name: "tempLinkSoft",
      component: () => import("@/pages/soft/lab-temp-link-soft/tempLink.vue"),
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/activity/xktskx202311",
          name: "science",
          meta: {
            keepAlive: true,
            title: "小学科学特色资源",
            auth: true,
          },
          component: () =>
            import("@/pages/primary-school-features/primaryScienceHome"),
        },
        {
          path: "/activity/xktsyy202311",
          name: "english",
          meta: {
            keepAlive: true,
            title: "小学英语特色资源",
            auth: true,
          },
          component: () =>
            import("@/pages/primary-school-features/primaryEnglishHome"),
        },
        {
          path: "/activity/xktssx202311",
          name: "math",
          meta: {
            keepAlive: true,
            title: "小学数学特色资源",
            auth: true,
          },
          component: () =>
            import("@/pages/primary-school-features/primaryMathHome"),
        },
        {
          path: "/activity/xktsyw202311",
          name: "chinese",
          meta: {
            keepAlive: true,
            title: "小学语文特色资源",
            auth: true,
          },
          component: () =>
            import("@/pages/primary-school-features/primaryChineseHome"),
        },
        {
          path: "desktop",
          name: "desktop",
          meta: {
            keepAlive: true,
            title: "工作台",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/desktop/index"),
        },
        {
          path: "practical-experiment",
          name: "practical-experiment",
          meta: {
            keepAlive: true,
            title: "仿真实验",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/practical-experiment/index"),
        },
        {
          path: "lab",
          name: "lab",
          meta: {
            keepAlive: true,
            title: "仿真实验",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/lab/index"),
        },
        {
          path: "lab/welcome",
          name: "lab",
          meta: {
            keepAlive: true,
            title: "仿真实验欢迎页",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/lab/welcome"),
        },
        {
          path: "tech",
          name: "tech",
          meta: {
            keepAlive: true,
            title: "云资源",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/tech/index"),
        },
        {
          path: "exam",
          name: "exam",
          meta: {
            keepAlive: true,
            title: "备考",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/exam/index"),
        },
        {
          path: "mock",
          name: "mock",
          meta: {
            keepAlive: true,
            title: "升学",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/mock/index"),
        },
        {
          path: "bk",
          name: "bk",
          meta: {
            keepAlive: true,
            title: "备课空间",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/bk/index"),
        },

        {
          path: "jb",
          name: "jb",
          meta: {
            keepAlive: true,
            title: "集体备课",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/jb/index"),
        },
        {
          path: "bj",
          name: "bj",
          meta: {
            keepAlive: true,
            title: "备课检查",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/bj/index"),
        },
        {
          path: "search",
          name: "search",
          meta: {
            keepAlive: true,
            title: "搜索",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/search/home"),
        },
        {
          meta: {
            keepAlive: true,
            title: "搜索",
            auth: true,
          }, // 需要被缓存
          path: "search/result",
          component: () => import("@/pages/search/result"),
        },
        {
          meta: {
            keepAlive: true,
            title: "资料详情",
            auth: true,
          }, // 需要被缓存
          path: "soft/*.html",
          name: "soft",
          component: () => import("@/pages/soft/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "上好课同步",
            auth: true,
          }, // 需要被缓存
          path: "/shk/books",
          name: "content",
          component: () => import("@/pages/content/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "上好课备考",
            auth: true,
          }, // 需要被缓存
          path: "/shk/review",
          name: "content",
          component: () => import("@/pages/content/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "试卷详情",
            auth: true,
          },
          path: "/shk/paper/:paperId",
          name: "paper",
          component: () => import("@/pages/content/paper/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "试卷详情",
            auth: true,
          },
          path: "/shk/paper/preview/:paperId",
          name: "paperPreview",
          component: () => import("@/pages/content/paper/preview.vue"),
        },
        {
          meta: {
            title: "上好课欢迎页",
            auth: true,
          }, // 需要被缓存
          path: "/shk/welcome",
          name: "shkWelcome",
          component: () => import("@/pages/content/welcome.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "AI科学",
            auth: true,
          }, // 需要被缓存
          path: "sci",
          name: "sci",
          component: () => import("@/pages/sci/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "AI阅读",
            auth: true,
          }, // 需要被缓存
          path: "read",
          name: "read",
          component: () => import("@/pages/read/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "AI阅读",
            auth: true,
          }, // 需要被缓存
          path: "read/welcome",
          name: "readWelcome",
          component: () => import("@/pages/read/welcome.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "AI阅读-专辑详情",
            auth: true,
          }, // 需要被缓存
          path: "read/docpack/*.html",
          name: "readDocpack",
          component: () => import("@/pages/read/docpack/index.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "课程指南-信息科技",
            auth: true,
          }, // 需要被缓存
          path: "sci/zn/xxkj",
          name: "xxkj",
          component: () => import("@/pages/sci/zn/xxkj.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "课程指南-STEAM科创",
            auth: true,
          }, // 需要被缓存
          path: "sci/zn/steam",
          name: "steam",
          component: () => import("@/pages/sci/zn/steam.vue"),
        },
        {
          meta: {
            keepAlive: true,
            title: "英语词汇",
            auth: true,
          }, // 需要被缓存
          path: "vocabulary",
          name: "vocabulary",
          component: () => import("@/pages/vocabulary/index.vue"),
        },
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "school-based",
          name: "school-based",
          meta: {
            keepAlive: true,
            title: "校本",
            auth: true,
          },
          component: () => import("@/pages/school-based/index"),
        },
        {
          meta: {
            keepAlive: true,
            title: "数据统计",
            auth: true,
          }, // 需要被缓存
          path: "/school-based/statistical",
          component: () => import("@/pages//school-based/statistical"),
        },
        {
          meta: {
            keepAlive: true,
            title: "我的校本",
            auth: true,
          }, // 需要被缓存
          path: "/school-based/my",
          component: () => import("@/pages//school-based/my"),
        },
        {
          meta: {
            keepAlive: true,
            title: "资源审核",
            auth: true,
          }, // 需要被缓存
          path: "/school-based/resource/review",
          component: () => import("@/pages/school-based/review"),
        },
        {
          meta: {
            keepAlive: true,
            title: "使用报告-仿真实验室",
            auth: true,
          }, // 需要被缓存
          path: "/report/lab",
          component: () => import("@/pages/report/lab"),
        },
        {
          meta: {
            keepAlive: true,
            title: "使用报告-仿真实验室",
            auth: true,
          }, // 需要被缓存
          path: "/lab/playreport",
          component: () => import("@/pages/lab/playreport"),
        },
        {
          meta: {
            keepAlive: true,
            title: "使用报告-NB实验",
            auth: true,
          }, // 需要被缓存
          path: "/lab/visitreport",
          component: () => import("@/pages/lab/visitreport"),
        },
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "after-service",
          name: "after-service",
          meta: {
            keepAlive: true,
            title: "课后服务",
            auth: true,
          },
          component: () => import("@/pages/after-service/index"),
        },
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/zyk/books",
          name: "zykBooks",
          meta: {
            keepAlive: true,
            title: "同步",
            auth: true,
          },
          component: () => import("@/pages/zyk/books/index.vue"),
        },
        {
          path: "/zyk/review",
          name: "zykReview",
          meta: {
            keepAlive: true,
            title: "升学",
            auth: true,
          },
          component: () => import("@/pages/zyk/review/index.vue"),
        },
        {
          path: "/zyk/kpoints",
          name: "zykKpoints",
          meta: {
            keepAlive: true,
            title: "知识点",
            auth: true,
          },
          component: () => import("@/pages/zyk/kpoints/index.vue"),
        },
        {
          path: "/zyk/papers",
          name: "zykPapers",
          meta: {
            keepAlive: true,
            title: "试卷",
            auth: true,
          },
          component: () => import("@/pages/zyk/papers/index.vue"),
        },
        {
          path: "/zyk/xkts",
          name: "zykXkts",
          meta: {
            keepAlive: true,
            title: "学科特色",
            auth: true,
          },
          component: () => import("@/pages/zyk/xkts/index.vue"),
        },
        {
          path: "/zyk/sxxj",
          name: "zykSxxj",
          meta: {
            keepAlive: true,
            title: "衔接",
            auth: true,
          },
          component: () => import("@/pages/zyk/sxxj/index.vue"),
        },
        {
          path: "/zyk/word",
          name: "zykWord",
          meta: {
            keepAlive: true,
            title: "英语词汇",
            auth: true,
          },
          component: () => import("@/pages/zyk/word/index.vue"),
        },
        {
          path: "/zyk/mingxiao",
          name: "zykMingxiao",
          meta: {
            keepAlive: true,
            title: "名校",
            auth: true,
          },
          component: () => import("@/pages/zyk/mingxiao/index.vue"),
        },
        {
          path: "/zyk/juemi",
          name: "zykJuemi",
          meta: {
            keepAlive: true,
            title: "绝密",
            auth: true,
          },
          component: () => import("@/pages/zyk/juemi/index.vue"),
        },
        {
          path: "/zyk/juemi/welcome",
          name: "zykJuemiWelcome",
          meta: {
            keepAlive: true,
            title: "绝密欢迎页",
            auth: true,
          },
          component: () => import("@/pages/zyk/juemi/welcome.vue"),
        },
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/xiaoben/soft-list",
          name: "soft-list",
          meta: {
            keepAlive: true,
            title: "校本资源",
            auth: true,
          },
          component: () => import("@/pages/xiaoben/soft-list.vue"),
        },
        {
          path: "/xiaoben/dashboard",
          name: "dashboard",
          meta: {
            keepAlive: true,
            title: "资源统计",
            auth: true,
          },
          component: () => import("@/pages/xiaoben/dashboard.vue"),
        },
        {
          path: "/xiaoben/soft-review",
          name: "soft-review",
          meta: {
            keepAlive: true,
            title: "资料审核",
            auth: true,
          },
          component: () => import("@/pages/xiaoben/soft-review.vue"),
        },
        {
          path: "/xiaoben/user",
          name: "user",
          meta: {
            keepAlive: true,
            title: "我的校本",
            auth: true,
          },
          component: () => import("@/pages/xiaoben/user.vue"),
        },
      ],
    },
    {
      path: "/",
      component: equityLayout,
      children: [
        {
          path: "equity",
          name: "equity",
          meta: {
            keepAlive: true,
            title: "权益中心",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/equity/index"),
        },
        {
          path: "equity/:id",
          name: "equity-detail",
          meta: {
            keepAlive: true,
            title: "权益详情",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/equity/detail"),
        },
      ],
    },
    {
      path: "/user",
      name: "user",
      meta: {
        keepAlive: true,
        title: "个人信息",
        auth: true,
      }, //
      component: () => import("@/pages/user/index.vue"),
      children: [
        {
          path: "/",
          name: "home",
          meta: {
            keepAlive: true,
            title: "我的首页",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/home/index"),
        },
        {
          path: "account",
          name: "account",
          meta: {
            keepAlive: true,
            title: "个人信息",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/account/index"),
        },
        {
          path: "bind",
          name: "bind",
          meta: {
            keepAlive: true,
            title: "账号绑定",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/bind/index"),
        },
        {
          path: "safety",
          name: "safety",
          meta: {
            keepAlive: true,
            title: "账号安全",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/safety/index"),
        },
        {
          path: "download",
          name: "download",
          meta: {
            keepAlive: true,
            title: "我的下载",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/download/index"),
        },
        {
          path: "collection",
          name: "collection",
          meta: {
            keepAlive: true,
            title: "我的收藏",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/collection/index"),
        },
        {
          path: "problem",
          name: "problem",
          meta: {
            keepAlive: true,
            title: "问题反馈",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/problem/index"),
        },
        {
          path: "suggestion",
          name: "suggestion",
          meta: {
            keepAlive: true,
            title: "资料挑错记录",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/suggestion/index"),
        },
        {
          path: "resource",
          name: "resource",
          meta: {
            keepAlive: true,
            title: "书城资源卡",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/resource/index"),
        },
        {
          path: "renew",
          name: "renew",
          meta: {
            keepAlive: true,
            title: "更新日志",
            auth: true,
          }, // 需要被缓存
          component: () => import("@/pages/user/renew/index"),
        },
        {
          path: "follow",
          name: "follow",
          meta: {
            keepAlive: true,
            title: "我的关注",
            auth: true,
          },
          component: () => import("@/pages/user/follow/index.vue"),
        },
      ],
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/docpack/*.html",
          name: "docpack",
          meta: {
            keepAlive: true,
            title: "专辑详情",
            auth: true,
          },
          component: () => import("@/pages/docpack/detail"),
        },
      ],
    },
  ],
  mode: "history",
});

//解决重复点击路由时，控制台报错
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// Router.prototype.replace = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
//   return originalReplace.call(this, location).catch(err => err)
//  }
router.beforeEach(async (to, from, next) => {
  // console.log("from,to----", from, to);
  // 清空
  if (from.path.indexOf("/equity") > -1 || to.path.indexOf("/equity") > -1) {
    if (from.path.indexOf("/equity") > -1) {
      localStorage.removeItem(SHOW_APPLY_MODAL);
    }
    store.commit("changeUser", {});
  }
  let isNotEquityPage = to.path.indexOf("/equity") == -1;
  let isLabReportPage =
    to.path.indexOf("/lab/playreport") > -1 ||
    to.path.indexOf("/lab/visitreport") > -1;
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.auth) {
    if (!store.state.userInfo.userId && !isLabReportPage) {
      // 获取用户信息
      try {
        const res = isNotEquityPage
          ? await getUserInfo({
              containPhone: true,
            })
          : await getUserinfoRights();
        // console.log("获取用户信息", res);
        let userRoles = [];
        // console.log("res", res, isNotEquityPage, window.location.href);
        if (res && res.code === 200) {
          res.result.schoolLogo = res.result.schoolLogo
            ? res.result.schoolLogo
            : null;
          res.result.roles &&
            res.result.roles.forEach((role) => {
              if (
                role.simpleName.indexOf("wxt") > -1 &&
                userRoles.indexOf(1) == -1
              ) {
                // userRoles.push(1);
              } else if (
                role.simpleName.indexOf("scsy") > -1 &&
                userRoles.indexOf(2) == -1
              ) {
                userRoles.push(2);
              }
            });
          let roles = res.result.roles || [];
          let filterRoles =
            roles.filter(
              (role) =>
                role.simpleName.indexOf("hmkt") > -1 ||
                role.simpleName.indexOf("scsy") > -1
            ) || [];
          let isOnlyScsy = roles.length && filterRoles.length == roles.length;
          store.commit("changeUser", res.result);
          store.commit("changeUserRoles", userRoles);
          if (to.path === "/") {
            // 获取用户的功能模块
            try {
              const currentCourse = await util.getUserCourses(
                store,
                res.result
              );
              const data = await getUserModuleAuth({
                courseId: currentCourse.courseId,
              });
              console.log("====data", data);
              if (data.code === 200) {
                // 查找用户的默认首页
                let defaultFunction = null;
                data.result.functionList.forEach((item) => {
                  if (item.isDefault) {
                    defaultFunction = item;
                  } else if (
                    item.childFunctions &&
                    item.childFunctions.length
                  ) {
                    item.childFunctions.forEach((child) => {
                      if (child.isDefault) {
                        defaultFunction = child;
                      }
                    });
                  }
                });
                // const defaultFunction = data.result.functionList.find(
                //   (item) => item.isDefault === 1
                // );
                // console.log("默认课程", defaultFunction);
                if (isOnlyScsy) {
                  from && from.query?.xep_flag && !to.query.xep_flag
                    ? next({
                        path: "/lab",
                        query: { ...to.query, xep_flag: 1 },
                      })
                    : next({ path: "/lab" });
                } else {
                  let path = defaultFunction
                    ? defaultFunction.redirectUrl
                    : "/desktop";
                  // defaultFunction
                  //   ? next({ path: defaultFunction.redirectUrl })
                  //   : next({ path: "/desktop" });
                  from && from.query?.xep_flag && !to.query.xep_flag
                    ? next({
                        path,
                        query: { ...to.query, xep_flag: 1 },
                      })
                    : next({
                        path,
                      });
                }
              } else {
                from && from.query?.xep_flag && !to.query.xep_flag
                  ? next({
                      path: "/desktop",
                      query: { ...to.query, xep_flag: 1 },
                    })
                  : next({ path: "/desktop" });
              }
            } catch (err) {
              console.error(err);
            }
          } else {
            console.log(
              "test",
              from && from.query?.xep_flag && !to.query.xep_flag
            );
            from && from.query?.xep_flag && !to.query.xep_flag
              ? next({
                  path: to.path,
                  query: { ...to.query, xep_flag: 1 },
                })
              : next();
          }
        } else if (res && res.code === 104) {
          if (
            to.path.indexOf("/lab/playreport") == -1 &&
            to.path.indexOf("/lab/visitreport") == -1 &&
            to.path.indexOf("/soft") == -1 &&
            to.path.indexOf("/docpack") == -1 &&
            to.path.indexOf("/lab/cj") == -1
          ) {
            from && from.query?.xep_flag && !to.query.xep_flag
              ? next({ path: "/noauth", query: { ...to.query, xep_flag: 1 } })
              : next({ path: "/noauth" });
          } else {
            store.commit("changeUser", {
              noAuth: true,
            });
            from && from.query?.xep_flag && !to.query.xep_flag
              ? next({
                  path: to.path,
                  query: { ...to.query, xep_flag: 1 },
                })
              : next();
          }
        } else {
          if (
            window.location.href.indexOf("/equity") == -1 &&
            window.location.href.indexOf("/soft") == -1 &&
            window.location.href.indexOf("/docpack") == -1 &&
            window.location.href.indexOf("/lab/cj") == -1
          ) {
            console.log("去登录", LOGINURL);
            window.location.href = LOGINURL;
          } else {
            from && from.query?.xep_flag && !to.query.xep_flag
              ? next({
                  path: to.path,
                  query: { ...to.query, xep_flag: 1 },
                })
              : next();
          }
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      // console.log("页面", from && from.query?.xep_flag && !to.query.xep_flag);
      try {
        if (from && from.query?.xep_flag && !to.query.xep_flag) {
          await next({
            path: to.path,
            query: { ...to.query, xep_flag: 1 },
          });
        } else {
          await next();
        }
      } catch (error) {
        console.log("error---", error);
      }
    }
  } else {
    from && from.query?.xep_flag && !to.query.xep_flag
      ? next({
          path: to.path,
          query: { ...to.query, xep_flag: 1 },
        })
      : next();
  }
});
export default router;
